module.exports = __webpack_public_path__ + "img/keepLogo.b30f93c6.png";